import { isClientRendering } from '../../lib/helpers';

import { getLocalStorageItem, setLocalStorageItem } from '../../lib/webStorage';

const APP_SIDEBAR_STATE_STORAGE_KEY = 'AppSidebar/sidebarState';

export const getSidebarIsExpanded = () => {
    if (isClientRendering()) {
        if (APP_SIDEBAR_STATE_STORAGE_KEY in localStorage) {
            return (
                getLocalStorageItem(APP_SIDEBAR_STATE_STORAGE_KEY) ===
                'expanded'
            );
        }

        return true;
    }
    return true;
};

export const setSidebarIsExpanded = (isExpanded: boolean) => {
    if (isClientRendering()) {
        setLocalStorageItem(
            APP_SIDEBAR_STATE_STORAGE_KEY,
            isExpanded ? 'expanded' : 'collapsed',
        );
    }
};
